// Хелперы для новостных баннеров (админка).

// Значения enum Role на бэкенде, к которым можно адресовать баннер.
export const BANNER_ROLES = {
  CUSTOMER: 'CUSTOMER',
  PROVIDER: 'PROVIDER',
};

// Режимы аудитории в UI.
export const AUDIENCE_MODE = {
  ALL: 'ALL',        // targetRole = null, без списка пользователей
  CUSTOMER: 'CUSTOMER',
  PROVIDER: 'PROVIDER',
  USERS: 'USERS',    // адресный список targetUserIds
};

// Разбирает строку с ID (через запятую / перенос строки / пробел) в массив уникальных непустых значений.
export function parseUserIds(raw) {
  if (!raw) return [];
  const seen = new Set();
  const result = [];
  raw
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((id) => {
      if (!seen.has(id)) {
        seen.add(id);
        result.push(id);
      }
    });
  return result;
}

// Простая проверка UUID v1-v5.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function findInvalidUserIds(ids) {
  return ids.filter((id) => !UUID_RE.test(id));
}

// Определяет режим аудитории по данным баннера с сервера.
export function resolveAudienceMode(banner) {
  if (Array.isArray(banner?.targetUserIds) && banner.targetUserIds.length > 0) {
    return AUDIENCE_MODE.USERS;
  }
  if (banner?.targetRole === BANNER_ROLES.CUSTOMER) return AUDIENCE_MODE.CUSTOMER;
  if (banner?.targetRole === BANNER_ROLES.PROVIDER) return AUDIENCE_MODE.PROVIDER;
  return AUDIENCE_MODE.ALL;
}

// Убирает потенциально опасные теги/атрибуты из HTML перед превью (baseline-защита).
export function sanitizeBannerHtml(html) {
  if (!html) return '';
  return String(html)
    .replace(/<\s*script[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi, '')
    .replace(/<\s*script[^>]*>/gi, '')
    .replace(/\son\w+\s*=\s*"[^"]*"/gi, '')
    .replace(/\son\w+\s*=\s*'[^']*'/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
    .replace(/javascript:/gi, '');
}

// Короткий текстовый предпросмотр HTML-контента для таблицы.
export function htmlToPlainSnippet(html, maxLen = 90) {
  if (!html) return '';
  const text = String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}…`;
}

// Проверяет, активен ли баннер прямо сейчас (по окну startsAt/expiresAt).
export function isBannerLive(banner, now = Date.now()) {
  const starts = banner?.startsAt ? new Date(banner.startsAt).getTime() : null;
  const expires = banner?.expiresAt ? new Date(banner.expiresAt).getTime() : null;
  if (starts != null && !Number.isNaN(starts) && starts > now) return false;
  if (expires != null && !Number.isNaN(expires) && expires < now) return false;
  return true;
}
